import type { NutritionTarget, NutritionTargetEnvelope } from '@onflow/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../lib/api.js';

const TARGET_KEY = ['nutrition-target'] as const;

export function useNutritionTarget() {
  return useQuery({
    queryKey: TARGET_KEY,
    queryFn: () => api<NutritionTargetEnvelope>('/targets/nutrition'),
  });
}

export function useRecalculateNutritionTarget() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      api<{ target: NutritionTarget }>('/targets/nutrition/recalculate', { method: 'POST' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TARGET_KEY }),
  });
}
